import { colors } from '@ardoq/design-tokens';
import {
  BlocksViewLink,
  BlocksViewNode,
  BlocksViewVisualState,
} from '../types';
import {
  GraphEdgeBase,
  GraphInterface,
  LabelsInterface,
  PARENT_CHILD_LINE_TYPE,
  getUrlFieldValuesByReferenceId,
  isComponentGraphEdge,
} from '@ardoq/graph';
import { lineTypeDashArrays } from 'tabview/canvasRendering/consts';
import { APIReferenceType } from '@ardoq/api-types';

type CreateBlocksViewLink = (
  viewInterface: GraphInterface & LabelsInterface,
  graphEdge: GraphEdgeBase,
  nodeMap: Map<string, BlocksViewNode>,
  referenceType: APIReferenceType | null
) => BlocksViewLink;
const createLink: CreateBlocksViewLink = (
  viewInterface,
  graphEdge,
  nodeMap,
  referenceType
) => {
  const { modelId } = graphEdge;
  const dashArray =
    lineTypeDashArrays[referenceType?.line ?? PARENT_CHILD_LINE_TYPE];

  const itemLabels = graphEdge.getItemLabels();
  const labels = [];

  labels.push(itemLabels?.mainLabel ?? '');

  if (itemLabels?.otherLabels) {
    for (const otherLabel of itemLabels.otherLabels) {
      const str = otherLabel[2]
        ? otherLabel[0].concat(': ', otherLabel[1])
        : otherLabel[1];

      labels.push(str.trim());
    }
  }

  const urlFieldValuesByReferenceId = getUrlFieldValuesByReferenceId(
    viewInterface,
    [modelId]
  );

  // If this is false, we are dealing with parent-child edges
  const isLateralEdge = isComponentGraphEdge(graphEdge);

  const edgeColor =
    (isLateralEdge ? graphEdge.getCssColorAttributes().stroke : undefined) ??
    colors.black950;

  const globalTypeId = isLateralEdge ? graphEdge.getGlobalTypeId() : null;

  const link: BlocksViewLink = {
    modelId,
    source: nodeMap.get(graphEdge.source)!,
    target: nodeMap.get(graphEdge.target)!,
    labels: labels,
    lineBeginning: graphEdge.getLineBeginning(),
    lineEnding: graphEdge.getLineEnding(),
    visualState: BlocksViewVisualState.None,
    globalTypeId,
    dashArray,
    color: edgeColor,
    animation: null,
    urlFieldValues: urlFieldValuesByReferenceId?.get(modelId) ?? null,
  };

  return link;
};
export { createLink };
